import { ReactElement } from "react";
import { FormControl, IconButton, TextField, Tooltip } from "@mui/material";
import { IAxisLinear } from "../../../components/charts/types";
import SyncIcon from "@mui/icons-material/Sync";
import { IAcquisitionVariable } from "../types";

interface IProps {
  axis: IAxisLinear;
  setAxis: (axis: IAxisLinear) => void;
  metaData: IAcquisitionVariable | null;
}

const AxisPanel = ({ axis, setAxis, metaData }: IProps): ReactElement => {
  const updateItemsAnnotation = (field: keyof IAxisLinear, value: any) => {
    (axis[field] as any) = value;
    setAxis({ ...axis });
  };

  const refreshData = () => {
    if (metaData) {
      const newAxis = { ...axis };

      newAxis.minimum = metaData.axisMinimum ?? newAxis.minimum;
      newAxis.maximum = metaData.axisMaximum ?? newAxis.maximum;
      newAxis.name = metaData.axisName ?? newAxis.name;

      setAxis({ ...newAxis });
    }
  };

  return (
    <div className="display-flex-row mt-1">
      <TextField
        variant="standard"
        sx={{ margin: 1, minWidth: 260, width: 260 }}
        placeholder={"Title"}
        label={"Title"}
        value={axis.name}
        onChange={(event) => updateItemsAnnotation("name",  event.target.value as string)}
      />

      <FormControl>
        <TextField
          variant="standard"
          sx={{ margin: 1, minWidth: 100, width: 100 }}
          label={"Minimum"}
          value={axis.minimum}
          type="number"
          onChange={(event) => updateItemsAnnotation("minimum",  parseFloat(event.target.value as string))}
        />
      </FormControl>

      <FormControl>
        <TextField
          variant="standard"
          sx={{ margin: 1, minWidth: 100, width: 100 }}
          label={"Maximum"}
          value={axis.maximum}
          type="number"
          onChange={(event) => updateItemsAnnotation("maximum",  parseFloat(event.target.value as string))}
        />
      </FormControl>

      <FormControl>
        <TextField
          variant="standard"
          sx={{ margin: 1, minWidth: 100, width: 100 }}
          label={"Ticks"}
          value={axis.ticksCount}
          type="number"
          slotProps={{
            input: { inputProps: { min: 1, max: 10 } }
          }}
          onChange={(event) => updateItemsAnnotation("ticksCount",  parseFloat(event.target.value as string))}
        />
      </FormControl>

      <IconButton color="primary" onClick={refreshData} className="ml-2" style={{ width: 32, height: 32, marginTop: 15 }}>
        <Tooltip title={"Refresh"}>
          <SyncIcon/>
        </Tooltip>
      </IconButton>
    </div>
  );
};

export default AxisPanel;
